import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../teamschat-transcript-dialog.action';
import { TeamschatTranscriptDialogState } from '../teamschat-transcript-dialog.state';

import { AddCommitmentNotesResult } from './add-commitment-notes.action';

export function addCommitmentNotesResultReducer(
    state: TeamschatTranscriptDialogState,
    action: PayloadAction<ActionType, AddCommitmentNotesResult>,
): TeamschatTranscriptDialogState {
    const navigateCmtId =
        action.payload.commitmentInfo.find((e) => e.commitmentId)
            ?.commitmentId ?? undefined;
    const navigateDraftId =
        action.payload.commitmentInfo.find((e) => e.draftId)?.draftId ??
        undefined;

    return {
        ...state,
        navigateCmtId,
        navigateDraftId,
        willNavigate: action.payload.willNavigate ?? false,
    };
}
